<div class="modal-body col-sm-12 form-group">
    @if (true) {
        <form  [formGroup]="PlanForForm" (ngSubmit)="onPlanFormSubmit(PlanForForm.value);">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="ContextType" class="form-label">Diary Against<span style="color:red;">*</span></label>
                                <ng-select
                                    [items]="[{ id: '2', name: 'Case' }, { id: '1', name: 'Decision' }, { id: '0', name: 'Notice' }]"
                                    bindLabel="name"
                                    bindValue="id"
                                    formControlName="ContextType"
                                    (change)="onChangeContextType($event)"
                                    [clearable]="false"
                                    placeholder="Select Type">
                                </ng-select>
                                @if (f.ContextType.touched && f.ContextType.invalid) {
                                    @if (f.ContextType.errors?.['required']) {
                                        <div class="text-danger">
                                            <small>Diary Against is required.</small>
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="drpCaseNotice" class="form-label">Case/Notice (Ref No) <span style="color:red;">*</span></label>
                                <ng-select
                                    [items]="CaseNoticeList"
                                    [multiple]="false"
                                    formControlName="drpCaseNotice"
                                    bindLabel="refno"
                                    bindValue="ID"
                                    [selectableGroup]="true"
                                    [closeOnSelect]="true"
                                    placeholder="Select Case/Notice">
                                    <ng-template ng-option-tmp let-item="item">
                                        <span [title]="item.refno">{{item.refno}} 
                                            @if(item.type){
                                                ({{item.type}})
                                            }
                                            @if (item.NoticeDt) {
                                                ({{item.NoticeDt | date:'dd-MMM-yyyy'}})
                                            }
                                        </span>
                                    </ng-template>
                                    
                                </ng-select>
                                @if (f.drpCaseNotice.touched && f.drpCaseNotice.invalid) {
                                    @if (f.drpCaseNotice.errors?.['required']) {
                                        <div class="text-danger">
                                            <small>Case/Notice is required.</small>
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="PlanDate" class="form-label">Plan Date <span style="color:red;">*</span></label>
                                <mat-form-field class="fullwidth" appearance="outline" >
                                    <input matInput [min]="minDate" formControlName="PlanDate" [max]="maxDate" [matDatepicker]="pickerPlanupdate" placeholder="Choose a date">
                                    <mat-datepicker-toggle matSuffix [for]="pickerPlanupdate"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerPlanupdate></mat-datepicker>
                                </mat-form-field>
                                @if (f.PlanDate.touched && f.PlanDate.invalid) {
                                    @if (f.PlanDate.errors?.['required']) {
                                        <div class="text-danger">
                                            <small>Plan Date is required.</small>
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="PlanActionType" class="form-label"> <a href="{{RouteGMPlanActionType}}" target="_blank"> Plan Action Type </a> <span style="color:red;">*</span></label>
                                <ng-select
                                    [items]="planActionType"
                                    bindLabel="MainDescr"
                                    bindValue="hdID"
                                    formControlName="PlanActionType"
                                    placeholder="Not Selected"
                                    placeholder="Select plan action type">
                                </ng-select>
                                @if (f.PlanActionType.touched && f.PlanActionType.invalid) {
                                    @if (f.PlanActionType.errors?.['required']) {
                                        <div class="text-danger">
                                            <small>Plan Action Type is required.</small>
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="PlanActionfor" class="form-label"> <a href="{{RouteUserMaster}}" target="_blank">Plan Action For </a> <span style="color:red;">*</span></label>
                                <ng-select
                                    [items]="Manager"
                                    appendTo="body"
                                    bindLabel="name"
                                    bindValue="id1"
                                    formControlName="PlanActionfor"
                                    placeholder="Select Manager">
                                </ng-select>
                                @if (f.PlanActionfor.touched && f.PlanActionfor.invalid) {
                                    @if (f.PlanActionfor.errors?.['required']) {
                                        <div class="text-danger">
                                            <small>Plan Action For is required.</small>
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="PlanDescription" class="form-label">Plan Description <span style="color:red;">*</span></label>
                                <textarea class="form-control" formControlName="PlanDescription" rows="2" placeholder="Enter Action Description"></textarea>
                                @if (f.PlanDescription.touched && f.PlanDescription.invalid) {
                                    @if (f.PlanDescription.errors?.['required']) {
                                        <div class="text-danger">
                                            <small>Plan Description is required.</small>
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="InTime" class="form-label">Plan Time</label>
                                <div class="d-flex">
                                    <input type="time" class="form-control" formControlName="InTime" />
                                </div>
                                @if (f.InTime.touched && f.InTime.invalid) {
                                    <div class="text-danger">
                                        <small>Plan In Time is required.</small>
                                    </div>
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="AlertTime" class="form-label">Send Alert Email/Sms Before Days</label>
                                <input type="number" min="0" formControlName="AlertTime" class="form-control" placeholder="Enter Alert time Period" />
                                @if (f.AlertTime.touched && f.AlertTime.invalid) {
                                    <div class="text-danger">
                                        <small>Alert Time is required.</small>
                                    </div>
                                }
                                @if (false) {
                                    <ng-select
                                        [items]="[{ id: '0', name: 'No Alert' }, { id: '1', name: 'Minute' }, { id: '2', name: 'Hour' }, { id: '3', name: 'Day' }]"
                                        bindLabel="name"
                                        bindValue="id"
                                        formControlName="AlertType">
                                    </ng-select>
                                    <div class="col-sm-1 height-34" style="display:none;">Send Now &nbsp; &nbsp; <input type="CheckBox" formControlName="SendNow" value="1"></div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            @if (!HideButtonSubmit && (RightsID.includes('202024001') || RightsID.includes('202024021'))) {
            <div class="d-flex align-items-center justify-content-center my-3">
              <button class="btn btn-primary submit-btn small" type="submit">
                {{ButtonCaption}}
              </button>
            </div>
            }
        </form>
    }@else {
        <!-- <form #PlanFor="ngForm" [formGroup]="PlanForForm" (ngSubmit)="onPlanFormSubmit(PlanFor.value);">
            <div class="col-sm-4">Diary Against <span style="color:red;">*</span></div>
            <div class="col-sm-2">
                <ng-select
                    [items]="[{ id: '2', name: 'Case' }, { id: '1', name: 'Decision' }, { id: '0', name: 'Notice' }]"
                    bindLabel="name"
                    bindValue="id"
                    formControlName="ContextType"
                    (change)="onChangeContextType($event)"
                    [clearable]="false"
                    placeholder="Select Type">
                </ng-select>
            </div>
            <div class="col-sm-5">
                <ng-select
                    [items]="CaseNoticeList"
                    [multiple]="false"
                    formControlName="drpCaseNotice"
                    bindLabel="refno"
                    bindValue="ID"
                    [selectableGroup]="true"
                    [closeOnSelect]="true">
                    <ng-template ng-option-tmp let-item="item">
                        {{item.refno}}&nbsp;&nbsp;&nbsp;({{item.type}})&nbsp;&nbsp;&nbsp;({{item.NoticeDt | date:'dd-MMM-yyyy'}})
                    </ng-template>
                </ng-select>
            </div>
            <div class="col-sm-1">&nbsp;</div>
    
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34">Plan Date<span style="color:red;">*</span></div>
            <div class="col-sm-7">
                <mat-form-field class="fullwidth" >
                    <input matInput [min]="minDate" formControlName="PlanDate" [max]="maxDate" [matDatepicker]="pickerPlanupdate" placeholder="Choose a date">
                    <mat-datepicker-toggle matSuffix [for]="pickerPlanupdate"></mat-datepicker-toggle>
                    <mat-datepicker #pickerPlanupdate></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-sm-1">&nbsp;</div>
    
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34"><a href="{{RouteGMPlanActionType}}" target="_blank">Plan Action Type</a></div>
            <div class="col-sm-7">
                <ng-select
                    [items]="planActionType"
                    bindLabel="MainDescr"
                    bindValue="hdID"
                    formControlName="PlanActionType"
                    placeholder="Not Selected">
                </ng-select>
            </div>
            <div class="col-sm-1">&nbsp;</div>
    
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34"><a href="{{RouteUserMaster}}" target="_blank">Plan of Action for</a></div>
            <div class="col-sm-7">
                <ng-select
                    [items]="Manager"
                    appendTo="body"
                    bindLabel="name"
                    bindValue="id1"
                    formControlName="PlanActionfor"
                    placeholder="Select Manager">
                </ng-select>
            </div>
            <div class="col-sm-1">&nbsp;</div>
    
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34">Plan Description <span style="color:red;">*</span></div>
            <div class="col-sm-7">
                <textarea class="form-control" formControlName="PlanDescription" rows="2" placeholder="Enter Action Description"></textarea>
            </div>
            <div class="col-sm-1">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34">Plan In Time</div>
            <div class="col-sm-2">
                <ng-select
                    [items]="hours"
                    bindLabel="name"
                    bindValue="id"
                    formControlName="InHour"
                    [clearable]="false"
                    placeholder="Hour">
                </ng-select>
            </div>
            <div class="col-sm-2">
                <ng-select
                    [items]="minutes"
                    bindLabel="name"
                    bindValue="id"
                    formControlName="InMin"
                    [clearable]="false"
                    placeholder="Minute">
                </ng-select>
            </div>
            <div class="col-sm-4">&nbsp;</div>
    
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34">Send Alert Email/Sms Before Days</div>
            <div class="col-sm-4">
                <input type="number" min="0" formControlName="AlertTime" class="form-control" placeholder="Enter Alert time Period" />
            </div>
            <div class="col-sm-1" style="display:none;">
                <ng-select
                    [items]="[{ id: '0', name: 'No Alert' }, { id: '1', name: 'Minute' }, { id: '2', name: 'Hour' }, { id: '3', name: 'Day' }]"
                    bindLabel="name"
                    bindValue="id"
                    formControlName="AlertType">
                </ng-select>
            </div>
            <div class="col-sm-1 height-34" style="display:none;">Send Now &nbsp; &nbsp; <input type="CheckBox" formControlName="SendNow" value="1"></div>
            <div class="col-sm-1 height-34" style="display:none;"></div>
    
            <div class="col-sm-12">
                <hr>
            </div>
            <div class="col-sm-4 ">&nbsp;</div>
            <div class="col-sm-4 " [hidden]="HideButtonSubmit"><br>
                <div class="form-group col-sm-4" *ngIf="this.RightsID.includes('202024001') || this.RightsID.includes('202024021'); then AddDiaryLink else AddDiaryNotLink"></div>
                <ng-template #AddDiaryLink>
                    <input class="btn btn-primary col-sm-12" type="submit" value={{ButtonCaption}}>
                </ng-template>
                <ng-template #AddDiaryNotLink>
                    &nbsp;
                </ng-template>
            </div>
            <div class="col-sm-4 ">&nbsp;</div>
            <div class="form-group mt-2" style="display:none;">
                <div class="form-check">
                    <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true [(ngModel)]="options.autoClose">
                    <label for="autoClose">Auto close alert after three seconds</label>
                </div>
            </div>
            <div class="jumbotron p-4">
                <div class="container text-center col-sm-4 alertCssforPopup">
                    <app-alert></app-alert>
                    <router-outlet></router-outlet>
                </div>
            </div>
        </form> -->
    }
</div>
